import styled from 'styled-components';
import { Icon } from '../Icon';

export const StyledHint = styled(Icon)`
    display: inline-block;
    margin-left: 5px;
    color: ${props => props.color};
`;
